import { ShieldCheck } from "lucide-react";
import LegalShell, { LegalSection } from "@/components/LegalShell";

/**
 * Política de Privacidad — public, static. Third-party processors are named
 * explicitly (Stripe, Anthropic, Railway, Resend). Placeholders are LITERAL so
 * the doc cannot be published with blanks unfilled.
 */
export default function PrivacyPage() {
  return (
    <LegalShell title="Política de Privacidad" updatedLabel="Última actualización: 2026-07-14">
      <p>
        Esta Política de Privacidad describe qué datos recogemos en The Trading Dock (la &ldquo;App&rdquo;), cómo los
        usamos y con qué terceros los compartimos. Tu privacidad es parte central de cómo construimos el producto.
      </p>

      <LegalSection id="datos-recogidos" heading="1. Qué datos recogemos">
        <ul className="list-disc pl-5 space-y-1.5 marker:text-violet-400">
          <li>
            <span className="text-white font-semibold">Datos de cuenta:</span> tu correo electrónico y tu nombre, para
            crear e identificar tu cuenta.
          </li>
          <li>
            <span className="text-white font-semibold">Datos financieros que ingresas manualmente:</span> las cuentas,
            transacciones, tarjetas y deudas que registras dentro de la App.
          </li>
          <li>
            <span className="text-white font-semibold">Imágenes de recibos:</span> las fotos de recibos que subes para que
            el escaneo por OCR extraiga los datos de la transacción.
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="datos-no-recogidos" heading="2. Qué NO recogemos">
        <div className="rounded-2xl border border-emerald-500/25 bg-emerald-500/10 p-4 sm:p-5">
          <div className="flex items-start gap-3">
            <ShieldCheck className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
            <p className="text-emerald-100/90">
              <span className="text-white font-semibold">Nunca pedimos ni almacenamos tus credenciales bancarias.</span> La
              App no tiene ninguna conexión directa con bancos ni instituciones financieras. Todo dato financiero lo
              ingresas tú a mano o mediante el escaneo de un recibo — no accedemos a tus cuentas bancarias.
            </p>
          </div>
        </div>
      </LegalSection>

      <LegalSection id="terceros" heading="3. Terceros que procesan tus datos">
        <p>Trabajamos con proveedores que procesan datos estrictamente para operar la App:</p>
        <ul className="list-disc pl-5 space-y-1.5 marker:text-violet-400">
          <li>
            <span className="text-white font-semibold">Stripe</span> — procesamiento de pagos. La App nunca almacena
            números de tarjeta; Stripe gestiona los datos de pago de forma segura.
          </li>
          <li>
            <span className="text-white font-semibold">Anthropic</span> — procesa las imágenes de recibos con inteligencia
            artificial para extraer los datos de la transacción.
          </li>
          <li>
            <span className="text-white font-semibold">Railway</span> — hosting de la infraestructura donde se ejecuta y
            almacena la App.
          </li>
          <li>
            <span className="text-white font-semibold">Resend</span> — envío de correos electrónicos transaccionales
            (confirmaciones, recibos, restablecimiento de contraseña).
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="retencion" heading="4. Retención y eliminación de datos">
        <p>
          Conservamos tus datos mientras tu cuenta esté activa. Tienes derecho a{" "}
          <span className="text-white font-semibold">eliminar tu cuenta y todos tus datos</span> en cualquier momento;
          al hacerlo, borramos tu información personal y financiera de nuestros sistemas, salvo lo que debamos conservar
          por obligación legal o para el registro de transacciones de pago.
        </p>
      </LegalSection>

      <LegalSection id="contacto" heading="5. Contacto">
        <p>
          Para ejercer tus derechos o para cualquier consulta sobre esta Política de Privacidad, escríbenos a{" "}
          <span className="text-white font-semibold">soporte@thetradingdock.com</span>.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
